import { render, staticRenderFns } from "./ArtigosChecklist.vue?vue&type=template&id=21d902ce&scoped=true&"
import script from "./ArtigosChecklist.vue?vue&type=script&lang=js&"
export * from "./ArtigosChecklist.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosChecklist.vue?vue&type=style&index=0&id=21d902ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d902ce",
  null
  
)

export default component.exports